export default __webpack_public_path__ + "471cb4284da013bbda023ee4a275f29c.svg";